<template>
  <div
    v-if="file != null && active"
    class="safety-file"
  >
    <pdf-preview-trigger
      v-if="file.Url"
      :url="file.Url"
      :share-url="file.ShareUrl"
    >
      <a
        class="safety-file__button download-link"
        :content-download-url="file.Url"
        content-download-type="pdf"
      >{{ button }}</a>
    </pdf-preview-trigger>
  </div>
</template>

<script>
export default {
  name: 'SafetyFile',
  props: {
    file: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    button: {
      type: String
    }
  }
}
</script>
